import { CAMPAIGN_STATE } from "../_constants";

import { campaignService } from "../_services";
import { alertActions, campaignActions, userActions } from "../_actions";

function normalizeCampaign(campaign, districtsObj) {
    if (campaign.params.zones) {
    } else {
        let districtArr = [];

        if (campaign.params && campaign.params.timeSlots) {
            campaign.params.timeSlots.map(timeSlot => {
                let zonesObj = timeSlot.zones;
                Object.keys(zonesObj).map(zoneCode => {
                    let f = districtArr.find(
                        element => element.code === zoneCode
                    );
                    if (f === undefined) {
                        districtArr.push(districtsObj[zoneCode]);
                    }

                    return zoneCode;
                });

                return timeSlot;
            });

            campaign.params.zones = districtArr;
        }
    }

    return campaign;
}

function getZonesString(campaign) {
    let zonesNames = [];
    if (campaign.params && campaign.params.zones) {
        zonesNames = campaign.params.zones.map(zone => zone.name);
    }
    return zonesNames.join(", ");
}

function getDisplayTimesString(campaign) {
    let timeSlotsDescriptions = [];
    if (campaign.params && campaign.params.timeSlots) {
        timeSlotsDescriptions = campaign.params.timeSlots.map(timeSlot =>
            getTimeSlotString(timeSlot, " - ")
        );
    }
    return timeSlotsDescriptions.join(", ");
}

function getTimeSlotString(timeSlot, joinItem) {
    return timeSlot.start + joinItem + timeSlot.end;
}

function getColor(campaign) {
    let color = CAMPAIGN_STATE.DENIED.color;

    switch (campaign.state) {
        case CAMPAIGN_STATE.DRAFTED.value:
            color = CAMPAIGN_STATE.DRAFTED.color;
            break;
        case CAMPAIGN_STATE.TOBEREVIEWED.value:
            color = CAMPAIGN_STATE.TOBEREVIEWED.color;
            break;
        case CAMPAIGN_STATE.APPROVED.value:
            color = CAMPAIGN_STATE.APPROVED.color;
            break;
        case CAMPAIGN_STATE.DENIED.value:
            color = CAMPAIGN_STATE.DENIED.color;
            break;
        case CAMPAIGN_STATE.STARTED.value:
            color = CAMPAIGN_STATE.STARTED.color;
            break;
        case CAMPAIGN_STATE.PAUSED.value:
            color = CAMPAIGN_STATE.PAUSED.color;
            break;
        case CAMPAIGN_STATE.FINISHED.value:
            color = CAMPAIGN_STATE.FINISHED.color;
            break;
        default:
            break;
    }

    return color;
}

function startCampaign(campaign, propsDispatch, additionalSuccessAction = null) {
    propsDispatch.dispatch(alertActions.loading("Loading...."));

    campaignService
        .updateCampaignState(campaign.id, CAMPAIGN_STATE.STARTED.value)
        .then(
            successfulData => {
                // this.props.onDismiss(null, null);
                additionalSuccessAction && additionalSuccessAction();

                propsDispatch.dispatch(campaignActions.getAll());

                // update account balance
                let updatedBalance = successfulData.updatedBalance;
                let user = JSON.parse(localStorage.getItem("user"));
                user.balance = updatedBalance;
                localStorage.setItem("user", JSON.stringify(user));

                propsDispatch.dispatch(
                    userActions.updateBalance(updatedBalance)
                );
            },
            error => {
                propsDispatch.dispatch(alertActions.error(error));
            }
        );
}
function finishCampaign(campaign, propsDispatch, additionalSuccessAction = null) {
    propsDispatch.dispatch(alertActions.loading("Loading...."));

    campaignService
        .updateCampaignState(campaign.id, CAMPAIGN_STATE.FINISHED.value)
        .then(
            successfulData => {
                // this.props.onDismiss(null, null);
                additionalSuccessAction && additionalSuccessAction();

                propsDispatch.dispatch(campaignActions.getAll());

            },
            error => {
                propsDispatch.dispatch(alertActions.error(error));
            }
        );
}
function resumeCampaign(campaign, propsDispatch, additionalSuccessAction = null) {
    propsDispatch.dispatch(alertActions.loading("Loading...."));

    campaignService
        .resumeCampaignState(campaign.id)
        .then(
            successfulData => {
                // this.props.onDismiss(null, null);
                additionalSuccessAction && additionalSuccessAction();

                propsDispatch.dispatch(campaignActions.getAll());

                let updatedBalance = successfulData.updatedBalance;
                let user = JSON.parse(localStorage.getItem("user"));
                user.balance = updatedBalance;
                localStorage.setItem("user", JSON.stringify(user));

                propsDispatch.dispatch(
                    userActions.updateBalance(updatedBalance)
                );

            },
            error => {
                propsDispatch.dispatch(alertActions.error(error));
            }
        );
}

function removeCampaign(campaign, propsDispatch, additionalSuccessAction = null) {
    campaignService.deleteCampaign(campaign.id).then(
        successfulData => {
            // this.props.onDismiss(null, null);
            additionalSuccessAction && additionalSuccessAction();
            propsDispatch.dispatch(campaignActions.getAll());

            let updatedBalance = successfulData.updatedBalance;
            let user = JSON.parse(localStorage.getItem("user"));
            user.balance = updatedBalance;
            localStorage.setItem("user", JSON.stringify(user));

            propsDispatch.dispatch(
                userActions.updateBalance(updatedBalance)
            );
        },
        error => {
            propsDispatch.dispatch(alertActions.error(error));
        }
    );
}

const Campaign = {
    getZonesString,
    getDisplayTimesString,
    getTimeSlotString,
    normalizeCampaign,
    getColor,
    startCampaign,
    resumeCampaign,
    removeCampaign,
    finishCampaign
};

export default Campaign;



// WEBPACK FOOTER //
// ./src/_helpers/campaign.js